<template>
  <CategoryEditModal>
    <template v-slot:card-title>
      <h3>Pick one topic</h3>
    </template>
    <template v-slot:card-subtitle>
      <p>Select a topic to customize the category.</p>
    </template>
    <template v-slot:card-body>
      <div class="bodybuttons-container">
        <BaseButton
          :class="{
            'selected-button': selectedTopic === 'Teaching & Acdemics',
          }"
          class="body-button"
          color="WHITE"
          @click="selectTopic('Teaching & Acdemics')"
          >Teaching & Acdemics</BaseButton
        >
        <BaseButton
          :class="{
            'selected-button': selectedTopic === 'Office Productivity',
          }"
          class="body-button"
          color="WHITE"
          @click="selectTopic('Office Productivity')"
          >Office Ptoductivity</BaseButton
        >
      </div>
    </template>
    <template v-slot:card-footer>
      <div class="stepone-footer">
        <div class="stepone-hint-container">
          <p class="stepone-hint"></p>
        </div>
        <BaseButton
          :class="nextButtonClasses"
          :color="nextButtonColor"
          @click="handleSubmit"
          >SUBMIT</BaseButton
        >
      </div>
    </template>
  </CategoryEditModal>
</template>

<script>
import CategoryEditModal from "@/components/category/CategoryEditModal.vue";
import BaseButton from "@/components/global/BaseButton.vue";

export default {
  components: {
    CategoryEditModal,
    BaseButton,
  },
  data() {
    return {
      selectedTopic: null,
    };
  },
  methods: {
    selectTopic(topic) {
      this.selectedTopic = this.selectedTopic === topic ? null : topic;
      if (this.selectedTopic) {
        // 发射事件，传递所选主题
        this.$emit("topicSelected", this.selectedTopic);
      }
    },
    handleSubmit() {
      if (this.selectedTopic) {
        // 发射一个自定义事件，告知父组件完成了主题的选择和提交动作
        this.$emit("submitComplete");
      }
    },
  },
  computed: {
    nextButtonColor() {
      return this.selectedTopic ? "PURPLE" : "GRAY";
    },
    nextButtonClasses() {
      return {
        "footer-button": true,
        "selected-button": this.selectedTopic,
        "no-focus": this.selectedTopic, // 如果有选中主题，则应用 no-focus 类
      };
    },
  },
};
</script>

<style scoped>
.selected-button:focus {
  border-color: #702dff; /* 设置焦点时边框颜色为紫色 */
  box-shadow: 0 0 0 0.1rem #ae76ff; /* 设置焦点时的阴影颜色 */
}
.stepone-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%; /* 容器占满宽度 */
  padding-right: 20px; /* 从右侧边缘留出一些空间 */
}

.stepone-hint {
  color: #fff;
  font-size: 14px;
  margin-right: 15px; /* 在提示文字和按钮之间留出空间 */
}

.body-button {
  width: 300px;
  font-size: 14px;
  font-weight: 450;
  margin: 0px 0px 15px 20px; /* 从两侧边缘留出一些空间 */
  border-radius: 15px !important;
}

.stepone-hint-container {
  display: flex;
  align-items: bottom; /* 垂直居下容器内的内容 */
}
.footer-button {
  width: 130px;
  margin: 0px 0px 20px 0px; /* 从两侧边缘留出一些空间 */
}
.bodybuttons-container {
  display: flex;
  flex-direction: column; /* 垂直排列按钮 */
  align-items: flex-start; /* 左对齐 */
}
.no-focus:focus {
  outline: none; /* 去除 focus 时的轮廓 */
  box-shadow: none; /* 去除 focus 时的阴影 */
}
</style>
